import { computed } from 'vue'
import { getUserData } from '@/auth/utils'
import { entityPatientPayment } from '@/libs/acl/entities'
import router from '@/router'
import { mixins } from '@/mixins'
import store from '@/store'
import ability from '@/libs/acl/ability'
import { msgBoxConfirmAction } from '@/composables/bvModal'

export default function treatmentDiaryHelper() {
  const canGoToPayment = computed(() => {
    const routeName = 'apps-cash-register'
    const user = getUserData()
    if (user) {
      return user.isRoot
        ? true : user.system_modules.includes(routeName) && ability.can('create', entityPatientPayment)
    }
    return false
  })

  const goToTreatmentDiariesList = diaryType => {
    let activeTab = mixins.methods.userHasProfmanDentalProgramVersion() ? 1 : diaryType === 'DENTAL' ? 2 : 1
    router.push({
      name: 'app-user-edit',
      params: {
        patientId: router.currentRoute.params.patientId,
        activeTabToShow: activeTab,
        routerBreadcrumbParams: {sourceItemLabel: store.state.patient.full_name}
      }
    })
  }

  const goToPaymentWithConfirm = async (
    paymentId, paymentDate, diaryType = 'DENTAL', goToTreatmentDiariesListOnCancel = false
  ) => {
    await msgBoxConfirmAction('Перейти к оплате в кассе?')
      .then(result => {
        if (result) {
          goToPayment(paymentId, paymentDate)
        } else if (goToTreatmentDiariesListOnCancel) {
          goToTreatmentDiariesList(diaryType)
        }
      })
  }

  const goToPayment = (paymentId, paymentDate) =>
    router.push({ name: 'apps-cash-register', params: { paymentId, paymentDate } })

  return {
    canGoToPayment,

    goToTreatmentDiariesList,
    goToPaymentWithConfirm,
    goToPayment,
  }
}
